import React from "react"
import { AnimatedSpeaking } from "./animatedSpeaking"
import { LocalPreviewProps } from "./types"



export const LocalPreview: React.FC<LocalPreviewProps> = ({
    videoRef,
    isCameraOn,
    isCameraStarting,
    isMicOn,
    isMyraSpeaking,
    userName,
}) => {
    return (
        <div className="relative w-full h-full overflow-hidden bg-gray-800 rounded-lg">
                <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    muted
                    style={{ transform: "scaleX(-1)" }}
                    className={`absolute inset-0 w-full h-full object-cover ${!isCameraOn ? "invisible" : "visible"}`}
                />

                {!isCameraOn && (
                    <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-gray-700">
                        <img
                            src={`https://ui-avatars.com/api/?name=${userName}&size=200&background=4338CA&color=fff&bold=true`}
                            alt="Camera Off"
                            className="rounded-full opacity-50"
                        />
                        {isCameraStarting && <p className="text-lg text-white animate-pulse">Camera starting...</p>}
                    </div>
                )}

                {/* Animated AI Speaking Indicator */}
                <div className="absolute top-0 z-10 w-20 h-20 overflow-hidden rounded-lg shadow-xl right-1 md:w-28 md:h-28 md:top-auto md:bottom-8 md:right-8">
                    <AnimatedSpeaking isSpeaking={isMyraSpeaking} />
                </div>

                {/* Microphone Off Warning */}
                {!isMicOn && (
                    <div className="absolute inset-x-0 z-20 px-6 top-4">
                        <div className="px-4 py-3 border-l-4 border-red-500 rounded-r-lg shadow-lg bg-red-50">
                            <div className="flex items-center gap-3">
                                <span className="text-2xl">🎤</span>
                                <div>
                                    <p className="text-sm font-semibold text-red-800">
                                        Microphone Disabled
                                    </p>
                                    <p className="text-xs text-red-600">
                                        Please enable your microphone in the browser to continue
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    )
}

